
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiIo as ObiIoElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-io.js';
 
 
 

 
 export const ObiIo = createComponent({
   react: React,
   tagName: 'obi-io',
   elementClass: ObiIoElement,
   events: {
     
   }
  });
 
 